import { ItemsCount } from "./ItemsCount";
import { Toolbar } from "./Toolbar";
import { ViewToggle } from "./ViewToggle";


export const Controls = () => { }

Controls.ItemsCount = ItemsCount;
Controls.Toolbar = Toolbar;
Controls.ViewToggle = ViewToggle;